import { overviewActions } from '../actions'

const {
  FETCHING_OVERVIEW,
  FETCH_OVERVIEW,
  FETCH_OVERVIEW_ERROR,
  FETCHING_OVERVIEW_LIST,
  FETCH_OVERVIEW_LIST,
  FETCH_OVERVIEW_LIST_ERROR,
  UPDATE_KIND,
  RESET_LIST,
  TOGGLE_PRODUCTS_TABLE
} = overviewActions

const initialState = {
  fetching: {
    overview: false,
    list: false
  },
  kindId: null,
  area_kinds: [],
  total_records: undefined,
  fetch_errors: {
    overview: false,
    list: false
  },
  products: [],
  showingProductsTable: false
}

const overview = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_OVERVIEW:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          overview: true
        },
        fetch_errors: {
          ...state.fetch_errors,
          overview: false
        }
      }

    case TOGGLE_PRODUCTS_TABLE:
      return {
        ...state,
        showingProductsTable: action.value
      }

    case FETCH_OVERVIEW:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          overview: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          overview: false
        },
        total_records: action.total_records,
        area_kinds: action.area_kinds
      }

    case FETCH_OVERVIEW_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          overview: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          overview: true
        }
      }

    case FETCHING_OVERVIEW_LIST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          list: true
        },
        products: []
      }

    case FETCH_OVERVIEW_LIST:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          list: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          list: false
        },
        products: action.products
      }

    case FETCH_OVERVIEW_LIST_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          list: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          list: true
        }
      }

    case UPDATE_KIND:
      return {
        ...state,
        kindId: action.value === state.kindId ? '' : action.value,
        products: []
      }

    case RESET_LIST:
      return {
        ...state,
        products: []
      }

    default:
      return state
  }
}

export default overview



// WEBPACK FOOTER //
// ./src/reducers/overview.js